var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearchDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4756 22C21.343 22 21.2108 21.9493 21.1086 21.8474L15.4906 16.2479C15.2835 16.042 15.2809 15.7037 15.4833 15.4935C15.6857 15.2828 16.0176 15.2796 16.2248 15.4861L21.8427 21.0856C22.0499 21.2915 22.0525 21.6298 21.8501 21.84C21.7478 21.9461 21.6115 22 21.4756 22Z",
    fill: "#1D2226"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77778 17.5556C5.48907 17.5556 2 14.067 2 9.77778C2 5.48907 5.48907 2 9.77778 2C14.0665 2 17.5556 5.48907 17.5556 9.77778C17.5556 14.067 14.0665 17.5556 9.77778 17.5556ZM9.77778 3.05686C6.07164 3.05686 3.05633 6.07163 3.05633 9.77831C3.05633 13.4845 6.07111 16.4998 9.77778 16.4998C13.4839 16.4998 16.4992 13.4845 16.4992 9.77831C16.4992 6.07216 13.4839 3.05686 9.77778 3.05686Z",
    fill: "#1D2226"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchDark);
export default __webpack_public_path__ + "static/media/iconSearchDark.151605827156c18d29328cbf8626bd42.svg";
export { ForwardRef as ReactComponent };